module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider4Pre-fb815a84.jpeg";